import { render, staticRenderFns } from "./accessdenied.vue?vue&type=template&id=48326bb5&scoped=true&"
import script from "./accessdenied.vue?vue&type=script&lang=js&"
export * from "./accessdenied.vue?vue&type=script&lang=js&"
import style0 from "./accessdenied.vue?vue&type=style&index=0&id=48326bb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48326bb5",
  null
  
)

export default component.exports